import { ChangeDetectionStrategy, Component, forwardRef, inject, OnChanges, OnInit } from '@angular/core';
import { Mask, ComponentsModule } from '../../../../../lib';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { SlotComponent } from '../slot.component';
import { RequiredMarkerPipe, TranslationKeyPipe, SlotTooltipPipe } from '../../../pipes';
import { MaskMapper } from '../../../services';
import { parseNGXMaskToNumber } from '../../../utils';
import { BlockParameterType } from '../../../interfaces';
import { VisualComponent } from '../../visual/visual.component';

@Component({
    selector: 'ca-slot-numeric-stepper',
    imports: [ComponentsModule, TranslationKeyPipe, SlotTooltipPipe, RequiredMarkerPipe, VisualComponent],
    templateUrl: './slot-numeric-stepper.component.html',
    styleUrl: './slot-numeric-stepper.component.scss',
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => SlotNumericStepperComponent),
            multi: true
        }
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SlotNumericStepperComponent extends SlotComponent implements OnInit, OnChanges {
    mask: Mask;
    private maskMapper = inject(MaskMapper);

    constructor() {
        super();
    }

    override ngOnInit() {
        setTimeout(() => {
            this.control.setValue(this.value());
        });
        super.ngOnInit();
    }

    override ngOnChanges() {
        this.mask = this.maskMapper.fromSlotToMask(this.slot());
    }

    override writeValue(value: any): void {
        this.value.set(value);
        this.control.setValue(value);
    }

    onValueChange(value: any) {
        if (this.isDisabled) {
            return;
        }

        if (this.slot()?.outputParameterType === BlockParameterType.Number) {
            value = parseNGXMaskToNumber(`${value}`);
        }
        this.value.set(value);
        this.control.setValue(value);
        this.control.markAsDirty();
        this.control.markAsTouched();
        this.onChange(value);
        this.onTouched();
    }

    get currentValue(): number {
        const raw = this.control.value ?? this.value();

        if (typeof raw === 'number') {
            return raw;
        }

        const parsed = parseInt(raw ?? 0, 10);
        return Number.isNaN(parsed) ? 0 : parsed;
    }
}
